{
  "routes": [
    {
      "icon": "email",
      "title": "Messenger",
      "activeArea": "Messenger",
      "drawer": {
        "title": "Unity Messenger",
        "groups": [
          {
            "title": "DIP",
            "collapsable": true,
            "items": [
              {
                "title": "Dashboard",
                "routerLink": "/market-messenger/dip/dashboard",
                "permissionData": ["UnityMessengerDashboard"],
                "icon": "dashboard"
              },
              {
                "title": "Billing",
                "routerLink": "/market-messenger/dip/billing",
                "permissionData": ["MessengerDIPBilling"],
                "icon": "payments"
              },
              {
                "title": "Service Plans",
                "routerLink": "/market-messenger/dip/service-plans",
                "permissionData": ["MessengerDIPServicePlanManagement"],
                "icon": "assured_workload"
              },
              {
                "title": "Message Audit Report",
                "routerLink": "/market-messenger/dip/message-audit-reports",
                "permissionData": ["MessageAuditReport"],
                "icon": "bar_chart_4_bars"
              }
            ]
          },
          {
            "title": "DTN",
            "collapsable": true,
            "insertHr": true,
            "items": [
              {
                "title": "Search Flows",
                "routerLink": "/market-messenger/dtn/search-flows",
                "permissionData": ["DTNMessengerSearchFlows"],
                "icon": "find_in_page"
              },
              {
                "title": "Manage Flow Jobs",
                "routerLink": "/market-messenger/dtn/manage-flow-jobs",
                "permissionData": ["DTNMessengerManageMessages"],
                "icon": "folder_data"
              },
              {
                "title": "Create Flow",
                "routerLink": "/market-messenger/dtn/flow-builder",
                "permissionData": [
                  {
                    "permissionName": "DTNMessengerFlowBuilder",
                    "permissionTypes": ["WriteAccess"]
                  }
                ],
                "icon": "create_new_folder"
              }
            ]
          },
          {
            "title": "Admin (DTN)",
            "collapsable": true,
            "items": [
              {
                "title": "Flow Configuration",
                "routerLink": "/market-messenger/dtn/route-config",
                "permissionData": ["DTNMessengerFlowConfiguration"],
                "icon": "folder_managed"
              },
              {
                "title": "Reports",
                "routerLink": "/market-messenger/dtn/reports",
                "permissionData": ["DTNMessengerReports"],
                "icon": "lab_profile"
              }
            ]
          }
        ]
      }
    },
    {
      "icon": "enhanced_encryption",
      "title": "Message Vault",
      "activeArea": "Message Vault",
      "drawer": {
        "title": "Vault",
        "groups": [
          {
            "items": [
              {
                "title": "Search Message Vault",
                "routerLink": "/message-vault/search",
                "permissionData": ["MessageVaultSearch"],
                "icon": "find_in_page"
              },
              {
                "title": "Service Plan Management",
                "routerLink": "/message-vault/service-plan-management",
                "permissionData": ["ServicePlanManagement"],
                "icon": "assured_workload"
              },
              {
                "title": "Billing",
                "routerLink": "/message-vault/billing",
                "permissionData": ["MessageVaultBilling"],
                "icon": "payments"
              }
            ]
          }
        ]
      }
    },
    {
      "icon": "bar_chart_4_bars",
      "title": "Reports",
      "activeArea": "Reports",
      "permissionData": [],
      "drawer": {
        "title": "Unity Reports",
        "groups": [
          {
            "items": [
              {
                "title": "Report Management",
                "routerLink": "reporting/manage-reports",
                "permissionData": ["ReportManagement"],
                "icon": "calendar_month"
              },
              {
                "title": "View Reports",
                "routerLink": "reporting/view-reports",
                "permissionData": ["ViewReports"],
                "icon": "manage_search"
              }
            ]
          }
        ]
      }
    },
    {
      "icon": "settings",
      "title": "Settings",
      "activeArea": "Settings",
      "routerLink": null,
      "drawer": {
        "title": "Unity Settings",
        "groups": [
          {
            "items": [
              {
                "title": "User Management",
                "routerLink": "/settings/user-management",
                "permissionData": ["UserManagement"],
                "icon": "manage_accounts"
              }
            ]
          }
        ]
      }
    }
  ]
}
